import { useParams } from "@tanstack/react-router";

import useNav from "core/hooks/useNav";

import { useStart } from "features/start/fabric";
import { useMutateCampaign, useQueryCampaign } from "areas/campaigns/data";


export const useCampaign = () => {
	const params = useParams({ from: "/campaigns/$id" });
	const start = useStart();
	const nav = useNav();

	const campaign = useQueryCampaign();
	const mutation = useMutateCampaign();

	const redeem = () => {
		if (!start.user) return nav.go({ to: "/auth", search: { sub_cmp: params.id } });
		mutation.mutate();
	};

	const title = (() => {
		if (campaign.data.status === "Ended") return "This campaign has ended.";
		else if (campaign.data.isRedeemed) return "You already redeemed this campaign.";
		else return "Redeem this offer from:";
	})();

	return { ...campaign, mutation, redeem, title };
};